export default __webpack_public_path__ + "static/media/create.5c8923bb.svg";